import { versionSearch } from '@app/const';

export function incrementVersion(version: string): string {
  if (
    typeof version !== 'string'
    || !versionSearch.test(version)
  ) {
    throw new Error(`Unable to increment invalid version "${version}".`);
  }

  const splitVersion = version.split('.');
  const oldPatchVersion = parseInt(splitVersion.pop() ?? '0', 10);

  return [
    ...splitVersion,
    oldPatchVersion + 1
  ].join('.');
}
